<template>
  <div class="orders-scheduler-tasks">
    <importer
      :active.sync="importModal.active"
      :validators="{
        'col-next-date': (date) => {
          return date ? (dateValidate(date) ? '' : 'Invalid date.') : '';
        },
        'col-end-date': (date) => {
          return date ? (dateValidate(date) ? '' : 'Invalid date.') : '';
        },
      }"
      :transformers="{
        'col-next-date': (date) => {
          return date ? dateParser(dateValidate(date)) : '';
        },
        'col-end-date': (date) => {
          return date ? dateParser(dateValidate(date)) : '';
        },
      }"
      @import="onImporterImport"
      @close="onImporterClose"
      ref="importer"
      v-if="contract"
    >
      <template #step1>
        <!-- <b-field label="Order Create Day">
          <b-datetimepicker
            v-model="importModal.form.order_create_day"
            horizontal-time-picker
            icon="calendar"
            :datetime-formatter="dateTimeFormatter"
          />
        </b-field> -->
        <base-select
          name="select_order_type"
          :service="$options.codeService"
          fetch-func="all"
          :fetch-params="{ type: 'orderType', contract_id: contract.id }"
          :value.sync="importModal.form.order_type"
          label="Order Type"
        />
        <base-select
          name="select_sub_type"
          :service="$options.codeService"
          fetch-func="chained"
          :fetch-params="{
            ids: [importModal.form.order_type],
            type: 'activityType',
            contract_id: contract.id,
          }"
          :fetch-on-init="false"
          :value.sync="importModal.form.order_subtype"
          label="Sub Type"
          :disabled="!importModal.form.order_type"
          ref="selectSubtype"
        />
        <base-select
          name="select_priority"
          :service="$options.codeService"
          fetch-func="childIntersection"
          :fetch-params="{
            ids: [importModal.form.order_type, importModal.form.order_subtype],
            type: 'orderPriority',
            contract_id: contract.id,
          }"
          :fetch-on-init="false"
          :value.sync="importModal.form.priority"
          value-key="name"
          label="Priority"
          :disabled="
            !importModal.form.order_type || !importModal.form.order_subtype
          "
          ref="selectPriority"
        />
        <b-field label="Order Description">
          <b-input
            v-model="importModal.form.order_description"
            type="textarea"
          ></b-input>
        </b-field>
        <!-- <base-select
          v-model="importModal.form.order_tag_id"
          :service="$options.tagService"
          fetch-func="all"
          :fetch-params="{
            type: '[ORDER][MANDATORY]',
            firm_id: contract.contractee_firm_id,
          }"
          label="Tag"
        ></base-select> -->
        <base-tag-input
          :value.sync="importModal.form.order_tag_names"
          :fetch-params="{
            type: '[ORDER][MANDATORY]',
          }"
          open-on-focus
          allow-new
        />
        <b-field label="Operation Description">
          <b-input
            v-model="importModal.form.operation_description"
            type="textarea"
          ></b-input>
        </b-field>
        <base-select
          v-model="importModal.form.failure_code_id"
          name="select_failure"
          :service="$options.codeService"
          fetch-func="childIntersection"
          :fetch-params="{
            ids: [importModal.form.order_type, importModal.form.order_subtype],
            type: 'FAILURE',
            contract_id: contract.id,
          }"
          :fetch-on-init="false"
          label="Default Failure Code"
          :disabled="
            !importModal.form.order_type || !importModal.form.order_subtype
          "
          ref="selectFailure"
        />
        <base-select
          v-model="importModal.form.repair_code_id"
          name="select_repair"
          :service="$options.codeService"
          fetch-func="childIntersection"
          :fetch-params="{
            ids: [importModal.form.order_type, importModal.form.order_subtype],
            type: 'REPAIR',
            contract_id: contract.id,
          }"
          :fetch-on-init="false"
          label="Default Repair Code"
          :disabled="
            !importModal.form.order_type || !importModal.form.order_subtype
          "
          ref="selectRepair"
        />
        <b-field label="End Date">
          <b-datepicker
            v-model="importModal.form.end_date"
            icon="calendar"
            :date-formatter="dateFormatter"
          />
        </b-field>
      </template>

      <template #footer-left>
        <b-button
          :loading="importModal.downloadingImportTemplate"
          :disabled="!importModal.canDownloadImportTemplate"
          @click="downloadImportTemplate"
        >
          Download Template
        </b-button>
      </template>
    </importer>

    <schedular-form-modal
      :active.sync="formModal.active"
      :contract="contract"
      :task="formModal.task"
      @submit="onFormSubmit"
    />

    <!-- <b-field grouped group-multiline>
      <base-select
        :service="$options.codeService"
        fetch-func="all"
        :fetch-params="{
          type: 'ASSET',
          contract_id: contract ? contract.id : undefined,
        }"
        :fetch-on-init="false"
        :value.sync="filters.assetType"
        label="Asset Type"
        default-option-label="All"
        ref="selectAssetType"
      />
    </b-field> -->

    <b-field label="Order Templates">
      <b-select v-model="orderTemplate">
        <option value>All</option>
        <option
          v-for="orderTemplate in orderTemplates"
          :value="orderTemplate.id"
          :key="orderTemplate.id"
        >
          {{
            orderTemplate.data
              ? orderTemplate.data.order_description
              : orderTemplate.id
          }}
        </option>
      </b-select>
    </b-field>

    <b-field label="Status">
      <b-field>
        <b-radio-button
          v-model="filters.status"
          native-value=""
          type="is-primary is-light is-outlined"
        >
          ALL
        </b-radio-button>
        <b-radio-button
          v-model="filters.status"
          native-value="active"
          type="is-primary is-light is-outlined"
        >
          ACTIVE
        </b-radio-button>
        <b-radio-button
          v-model="filters.status"
          native-value="archived"
          type="is-primary is-light is-outlined"
        >
          ARCHIVED
        </b-radio-button>
      </b-field>
    </b-field>

    <b-field grouped>
      <!-- <b-field>
        <b-radio v-model="generateMode" native-value=""> BASIC </b-radio>
        <b-radio v-model="generateMode" native-value="advanced"> ADVANCED </b-radio>
      </b-field> -->
      <!-- <b-field label="Generate Start Date">
        <b-datepicker
          v-model="generateStartDate"
          icon="calendar"
          :placeholder="generateStartDatePlaceholder"
          :date-formatter="dateFormatter"
        />
      </b-field>
      <b-field label="Generate End Date">
        <b-datepicker
          v-model="generateEndDate"
          icon="calendar"
          :placeholder="generateEndDatePlaceholder"
          :date-formatter="dateFormatter"
        />
      </b-field> -->
      <b-field label="Generate Date">
        <b-select v-model="generateDate" placeholder="No contract selected">
          <option v-for="date in generateDates" :value="date" :key="date">
            {{ date }}
          </option>
        </b-select>
      </b-field>
    </b-field>

    <div class="buttons mb-1">
      <b-button :disabled="!contract" type="is-light" @click="createTask">
        CREATE
      </b-button>
      <b-button :disabled="!contract" type="is-light" @click="onImportClick">
        IMPORT
      </b-button>
      <b-button
        :disabled="!canManageScheduledOrders || generateBusy"
        type="is-dark"
        @click="generateTasks"
      >
        GENERATE
      </b-button>
      <b-button
        :disabled="!canManageScheduledOrders || generateBusy"
        type="is-warning"
        @click="generateUndo"
      >
        UNDO
      </b-button>
    </div>

    <div
      class="import-result card"
      style="margin-bottom: 30px; max-width: 1000px"
      v-if="importModal.result"
    >
      <header class="card-header">
        <p class="card-header-title">Import Result</p>
        <div class="buttons">
          <b-button icon-right="download" @click="downloadImportResult" />
        </div>
      </header>
      <div class="card-content">
        <table class="table is-fullwidth">
          <tbody v-if="importModal.result.length">
            <tr v-for="(row, key) in importModal.result" :key="key">
              <template v-for="(col, colKey) in row">
                <th v-if="key == 0" :key="colKey">
                  {{ col }}
                </th>
                <td
                  :class="getImportResultClass(key, colKey)"
                  :key="colKey"
                  v-else
                >
                  {{ col }}
                </td>
              </template>
              <td v-if="importModal.fromForm && key != 0">
                <b-button size="is-small" @click="editImportResult">
                  EDIT
                </b-button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td>No results</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- <base-table
      :service="$options.maintenanceTaskService"
      fetch-func="all"
      :fetch-params="tableFetchParams"
      :columns="columns"
      sticky
      class="tasks-table"
      @fetch="onTableFetch"
      ref="baseTable"
    >
      <template #rowActions="{ row }">
        <div class="buttons" style="flex-wrap: nowrap">
          <b-button size="is-small" @click="() => editTask(row)">
            EDIT
          </b-button>
          <b-button
            size="is-small"
            type="is-success"
            @click="() => restoreTask(row.id)"
            v-if="row.archived_at"
          >
            RESTORE
          </b-button>
          <b-button
            size="is-small"
            type="is-warning"
            @click="() => archiveTask(row.id)"
            v-else
          >
            ARCHIVE
          </b-button>
        </div>
      </template>
    </base-table> -->

    <schedular-table
      :tasks="tasksFiltered"
      :loading="loading"
      @edit="editTask"
      @restore="restoreTask"
      @archive="archiveTask"
    />
  </div>
</template>

<script>
import moment from "moment";
import BaseSelect from "@/components/partials/BaseSelect";
import BaseTagInput from "@/components/partials/BaseTagInput";
import BaseTable from "@/components/partials/BaseTable";
import Importer from "@/components/Importer/Importer";
import SchedularFormModal from "@/components/Schedular/SchedularFormModal";
import SchedularTable from "@/components/Schedular/SchedularTable";
import { CodeService } from "@/services/code.service";
import { MaintenanceTaskService } from "@/services/maintenanceTask.service";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { datepickerMixin } from "@/mixins/datepickerMixin";
import { parse as parseCsv } from "@/helpers/csv-parser";

export default {
  codeService: CodeService,
  maintenanceTaskService: MaintenanceTaskService,
  tagService: TagService,
  mixins: [datepickerMixin],
  components: {
    BaseSelect,
    BaseTagInput,
    BaseTable,
    Importer,
    SchedularFormModal,
    SchedularTable,
  },
  props: {
    contract: {
      type: Object,
    },
  },
  data: () => ({
    generateBusy: false,
    generateMode: "advanced",
    generateDates: [],
    generateDate: null,
    generateStartDate: null,
    generateEndDate: null,
    // columns: [
    //   {
    //     field: "orderTypeCode.name",
    //     label: "Order Type",
    //   },
    //   {
    //     field: "orderSubtypeCode.name",
    //     label: "Sub Type",
    //   },
    //   {
    //     field: "priority",
    //     label: "Priority",
    //   },
    //   {
    //     field: "activityCode.name",
    //     label: "Activity Code",
    //   },
    //   {
    //     field: "failureCode.name",
    //     label: "Failure Code",
    //   },
    //   {
    //     field: "repairCode.name",
    //     label: "Repair Code",
    //   },
    //   {
    //     field: "assetFirm.name",
    //     label: "Asset Firm",
    //   },
    //   {
    //     field: "asset.thirdPartyCode",
    //     label: "Asset",
    //   },
    //   {
    //     field: "parentAsset.thirdPartyCode",
    //     label: "Parent Asset",
    //   },
    //   {
    //     field: "rate.code",
    //     label: "Rate",
    //   },
    //   {
    //     field: "assetCode.name",
    //     label: "Asset Type",
    //   },
    //   {
    //     field: "frequency",
    //     label: "Frequency",
    //   },
    //   {
    //     field: "next_date",
    //     label: "Next Date",
    //     meta: {
    //       filter: "formattedDate",
    //       filterOptions: { format: "DD-MMM-YYYY" },
    //     },
    //   },
    //   {
    //     field: "end_date",
    //     label: "End Date",
    //     meta: {
    //       filter: "formattedDate",
    //       filterOptions: { format: "DD-MMM-YYYY" },
    //     },
    //   },
    //   {
    //     field: "actions",
    //     label: "",
    //     meta: {
    //       rowSlot: "rowActions",
    //     },
    //   },
    // ],
    tasks: [],
    orderTemplate: "",
    filters: {
      assetType: "",
      status: "",
    },
    importModal: {
      active: false,
      form: {
        // order_create_day: new Date(),
        order_type: "",
        order_subtype: "",
        priority: "",
        order_description: "",
        // order_tag_id: "",
        order_tag_names: [],
        operation_description: "",
        failure_code_id: "",
        repair_code_id: "",
        end_date: null,
      },
      file: null,
      result: null,
      resultBlob: null,
      loading: false,
      canDownloadImportTemplate: false,
      downloadingImportTemplate: false,
      fromForm: false, // submitted from create/edit modal (not on import modal)
    },
    formModal: {
      active: false,
    },
    loading: false,
  }),
  computed: {
    tableFetchParams() {
      let params = {
        contract_id: this.contract ? this.contract.id : undefined,
        asset_code_id: this.filters.assetType || undefined,
        includes:
          "orderTypeCode,orderSubtypeCode,activityCode,failureCode,repairCode,assetCode,asset,parentAsset,assetFirm,rate,tags,headerLog",
      };
      switch (this.filters.status) {
        case "active":
          params.active = 1;
          break;
        case "archived":
          params.archived = 1;
          break;
      }
      return params;
    },
    canManageScheduledOrders() {
      return this.$store.getters["Auth/hasPermission"](
        "can manage scheduled orders"
      );
    },
    // generateStartDatePlaceholder() {
    //   if (this.contract && this.contract.financial_month) {
    //     const d = moment();
    //     d.set("date", this.contract.financial_month);
    //     d.add(1, "months");
    //     return d.format("DD/MM/YYYY");
    //   }
    //   return "";
    // },
    // generateEndDatePlaceholder() {
    //   if (this.contract && this.contract.financial_month) {
    //     const d = moment();
    //     d.set("date", this.contract.financial_month);
    //     d.add(2, "months");
    //     d.subtract(1, "days");
    //     return d.format("DD/MM/YYYY");
    //   }
    //   return "";
    // },
    generateDatePlaceholder() {
      const d = moment();
      d.add(1, "months");
      return d.format("MMM YYYY");
    },
    // Header logs
    orderTemplates() {
      let orderTemplates = {};
      this.tasks.forEach((v) => {
        if (v.headerLog) {
          if (!orderTemplates[v.headerLog.id]) {
            orderTemplates[v.headerLog.id] = v.headerLog;
          }
        }
      });
      return Object.values(orderTemplates);
    },
    tasksFiltered() {
      if (this.orderTemplate) {
        return this.tasks.filter(
          (v) => v.headerLog && v.headerLog.id == this.orderTemplate
        );
      } else {
        return this.tasks;
      }
    },
  },
  mounted() {
    // this.getGenerateDates();
  },
  watch: {
    filters: {
      handler: function () {
        this.$nextTick(() => {
          this.fetchTasks();
        });
      },
      deep: true,
    },
    contract(contract) {
      this.$nextTick(() => {
        this.orderTemplate = "";
        this.fetchTasks();
        this.getGenerateDates();
        if (contract) {
          //this.$refs.selectAssetType.fetchOptions();
        } else {
          //this.$refs.selectAssetType.options = [];
        }
      });
    },
    // orderTemplate(orderTemplate) {
    //   if (orderTemplate) {
    //     this.$refs.baseTable.data = this.tasks.filter(
    //       (v) => v.headerLog && v.headerLog.id == orderTemplate
    //     );
    //   } else {
    //     this.$refs.baseTable.data = this.tasks;
    //   }
    // },
    "importModal.form": {
      handler: function () {
        this.canDownloadImportTemplate();
      },
      deep: true,
    },
    "importModal.form.order_type"() {
      this.importModal.form.order_subtype = "";
      this.$nextTick(() => {
        if (this.importModal.form.order_type) {
          this.$refs.selectSubtype.fetchOptions();
        }
      });
    },
    "importModal.form.order_subtype"() {
      this.importModal.form.priority = "";
      this.importModal.form.failure_code_id = "";
      this.importModal.form.repair_code_id = "";
      this.$nextTick(() => {
        if (
          this.importModal.form.order_type &&
          this.importModal.form.order_subtype
        ) {
          this.$refs.selectPriority.fetchOptions();
          this.$refs.selectFailure.fetchOptions();
          this.$refs.selectRepair.fetchOptions();
        }
      });
    },
  },
  methods: {
    dateTimeFormatter(date) {
      if (date) {
        return moment(date).format("DD-MMM-YYYY HH:mm");
      }
    },
    canCreateTasks() {
      if (!this.contract) {
        this.$buefy.toast.open({
          message: "No contract selected.",
          type: "is-danger",
          position: "is-top-right",
        });
        return;
      }
      if (!this.contract.financial_month) {
        this.$buefy.toast.open({
          message: "No contract financial month loaded.",
          type: "is-danger",
          position: "is-top-right",
        });
        return;
      }
      return true;
    },
    async fetchTasks() {
      // if (this.contract) {
      //   await this.$refs.baseTable.fetchData();
      // } else {
      //   this.$refs.baseTable.data = [];
      // }

      if (this.contract) {
        try {
          this.loading = true;
          this.tasks = await MaintenanceTaskService.all({
            ...this.tableFetchParams,
            per_page: 10000,
          }).then((response) => JsonDenormalizer.denormalize(response));
        } catch (err) {
        } finally {
          this.loading = false;
        }
      } else {
        this.tasks = [];
      }
    },
    async importTasks(form, fromForm = false) {
      try {
        this.$refs.importer.loading = true;
        const data = new FormData();
        data.append(
          "contract_id",
          this.contract ? this.contract.id : undefined
        );
        // data.append("file", file);
        // Object.entries(this.importModal.form).forEach(([key, value]) => {
        //   if (value) data.append(key, value);
        // });
        Object.entries(form).forEach(([key, value]) => {
          if (value) data.append(key, value);
        });
        await MaintenanceTaskService.import(data, {
          responseType: "blob",
        }).then(async (response) => {
          let result = await response.text();
          // result = result.split("\n");
          // result.pop();
          // result = result.map((row) =>
          //   row.split(",").map((d) => d.replace(/"/g, ""))
          // );
          result = parseCsv(result);
          this.importModal.result = result;
          this.importModal.resultBlob = response;
          this.importModal.fromForm = fromForm;
        });
        this.$buefy.toast.open({
          message: "Imported successfully.",
          type: "is-info",
          position: "is-top-right",
        });
        await this.fetchTasks();
      } catch (err) {
        // throw err;
        console.error(err);
      } finally {
        // Clear import form
        this.$refs.importer.close();
      }
    },
    editImportResult() {
      let form = this.formModal.form;
      let task = {
        headerLog: {
          data: {
            order_description: form.order_description || "",
          },
        },
        order_type: form.order_type || "",
        order_subtype: form.order_subtype || "",
        priority: form.priority || "",
        tags: form.tags ? form.tags.map((v) => ({ name: v })) : [],
        failure_code_id: form.failure_code_id || "",
        repair_code_id: form.repair_code_id || "",
        parentAsset: { thirdPartyCode: form.parent_asset_code || "" },
        asset: { thirdPartyCode: form.asset_code || "" },
        assetCode: { code: form.asset_type || "" },
        activity_code_id: form.activity_code_id,
        activityCode: { code: form.activity_code || "" },
        rate: { code: form.rate_code || "" },
        description: form.operation_description || "",
        frequency: form.frequency || "",
        next_date: form.next_date || "",
        end_date: form.end_date || "",
      };
      this.formModal.task = task;
      this.formModal.active = true;
    },
    downloadImportResult() {
      const url = window.URL.createObjectURL(this.importModal.resultBlob);
      const link = document.createElement("a");
      link.href = url;
      const random = (Math.random() + 1).toString(36).substring(7);
      link.setAttribute("download", `import_result_${random}.csv`);
      document.body.appendChild(link);
      link.click();
    },
    getImportResultClass(rowKey, colKey) {
      let resultClass = this.importModal.result[0][colKey]
        .replace(" ", "-")
        .toLowerCase();
      if (resultClass === "tags") {
        resultClass = "col-tags";
      }
      if (resultClass === "status") {
        if (this.importModal.result[rowKey][colKey] != "OK") {
          resultClass = "status status-fail";
        }
      }
      return resultClass;
    },
    async downloadImportTemplate() {
      try {
        this.importModal.downloadingImportTemplate = true;
        await MaintenanceTaskService.downloadImportTemplate(
          {
            contract_id: this.contract.id,
            ...this.importModal.form,
          },
          {
            responseType: "blob",
          }
        ).then(async (response) => {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const random = (Math.random() + 1).toString(36).substring(7);
          link.setAttribute("download", `import_template_${random}.csv`);
          document.body.appendChild(link);
          link.click();
        });
      } catch (err) {
        throw err;
      } finally {
        this.importModal.downloadingImportTemplate = false;
      }
    },
    async canDownloadImportTemplate() {
      if (
        this.contract &&
        this.importModal.form.order_type &&
        this.importModal.form.order_subtype &&
        this.importModal.form.failure_code_id &&
        this.importModal.form.repair_code_id
      ) {
        this.importModal.downloadingImportTemplate = true;
        this.importModal.canDownloadImportTemplate =
          await MaintenanceTaskService.downloadImportTemplate({
            contract_id: this.contract.id,
            ...this.importModal.form,
          }).then((response) => (response ? response.success : true));
        this.importModal.downloadingImportTemplate = false;
      } else {
        this.importModal.canDownloadImportTemplate = false;
      }
    },
    getGenerateDates() {
      const generateDates = [];
      if (
        this.contract &&
        this.contract.generate_schedule &&
        this.contract.financial_month
      ) {
        let d = moment();
        for (let x = 0; x < 12; x++) {
          if (x == 0) {
            let generate_schedule_day = moment
              .utc(this.contract.generate_schedule)
              .local();
            generate_schedule_day = generate_schedule_day.date();
            let financial_month_day = moment
              .utc(this.contract.financial_month)
              .local();
            financial_month_day = financial_month_day.date();
            console.log(generate_schedule_day, financial_month_day);
            if (generate_schedule_day > financial_month_day) {
              d.add(1, "months");
            }
          } else {
            d.add(1, "months");
          }
          generateDates.push(d.format("MMM YYYY"));
        }
      }
      this.generateDates = generateDates;
      this.generateDate = generateDates.length ? generateDates[0] : null;
    },
    async generateTasks() {
      if (!this.canManageScheduledOrders) return;
      if (!this.canCreateTasks()) return;
      try {
        this.generateBusy = true;
        let start_date = null;
        // let generate_schedule = null;
        if (this.generateDate) {
          let financial_month = moment
            .utc(this.contract.financial_month)
            .local();
          start_date = moment(new Date(this.generateDate));
          start_date.set({
            date: financial_month.date(),
            hour: financial_month.hour(),
            minute: financial_month.minute(),
          });
          start_date = this.dateParser(start_date);

          // generate_schedule = moment(new Date(this.generateDate));
          // generate_schedule.subtract(1, "month");
          // generate_schedule.endOf("month");
          // generate_schedule = this.dateParser(generate_schedule);
        }
        const response = await MaintenanceTaskService.generate({
          contract_id: this.contract ? this.contract.id : undefined,
          mode: this.generateMode || undefined,
          start_date: start_date || undefined,
          // start_date:
          //   this.generateStartDate && this.generateEndDate
          //     ? this.dateParser(this.generateStartDate)
          //     : undefined,
          // end_date:
          //   this.generateStartDate && this.generateEndDate
          //     ? this.dateParser(this.generateEndDate)
          //     : undefined,
          // generate_schedule: generate_schedule || undefined,
          manual: 1,
        });
        this.$buefy.notification.open({
          duration: 10000,
          message: `Order generation has been completed. <div id="generated-scheduled-log-ids">${(
            response.data || []
          ).join(",")}</div>`,
          type: "is-info",
          position: "is-top-right",
        });
        this.$emit("generate");
      } catch (err) {
        throw err;
      } finally {
        this.generateBusy = false;
      }
    },
    createTask() {
      if (this.canCreateTasks()) {
        this.formModal.task = null;
        this.formModal.active = true;
      }
    },
    editTask(task) {
      if (this.canCreateTasks()) {
        this.formModal.task = task;
        this.formModal.active = true;
      }
    },
    async archiveTask(taskId) {
      try {
        // this.$refs.baseTable.loading = true;
        this.loading = true;
        await MaintenanceTaskService.archive(taskId);
        await this.fetchTasks();
        this.$buefy.toast.open({
          message: "Orders has been archived.",
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
        throw err;
      } finally {
        // this.$refs.baseTable.loading = false;
        this.loading = false;
      }
    },
    async restoreTask(taskId) {
      try {
        // this.$refs.baseTable.loading = true;
        this.loading = true;
        await MaintenanceTaskService.restore(taskId);
        await this.fetchTasks();
        this.$buefy.toast.open({
          message: "Orders has been restored.",
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
        throw err;
      } finally {
        // this.$refs.baseTable.loading = false;
        this.loading = false;
      }
    },
    async generateUndo() {
      if (!this.canManageScheduledOrders) return;
      try {
        this.generateBusy = true;
        await MaintenanceTaskService.generateUndo();
        this.generateBusy = false;
        this.$buefy.toast.open({
          message: "Order generation has been undone.",
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
        this.generateBusy = false;
        throw err;
      }
    },
    onImportClick() {
      if (this.canCreateTasks()) {
        this.importModal.active = true;
      }
    },
    onImporterImport(file) {
      this.importTasks({
        ...this.importModal.form,
        order_tag_names: (this.importModal.form.order_tag_names || []).length
          ? this.importModal.form.order_tag_names
          : undefined,
        // order_create_day: this.dateParser(
        //   this.importModal.form.order_create_day
        // ),
        end_date: this.importModal.form.end_date
          ? this.dateParser(this.importModal.form.end_date)
          : undefined,
        file,
      });
    },
    onImporterClose() {
      // Reset form
      this.importModal.form = {
        // order_create_day: new Date(),
        order_type: "",
        order_subtype: "",
        priority: "",
        order_description: "",
        // order_tag_id: "",
        order_tag_names: [],
        operation_description: "",
        failure_code_id: "",
        repair_code_id: "",
        end_date: null,
      };
    },
    async onFormSubmit(form) {
      this.formModal.form = form;
      // Convert to csv file
      let data = [
        [
          "Parent Asset Code",
          "Asset Type",
          "Asset Code",
          "Asset Owner",
          "Activity Code",
          "Rate Code",
          "Task",
          "Frequency",
          "Next Date",
          "End Date",
        ],
        [
          form.parent_asset_code,
          form.asset_type,
          form.asset_code,
          "",
          form.activity_code,
          form.rate_code,
          form.operation_description,
          form.frequency,
          form.next_date,
          form.end_date,
        ],
      ];
      // Update
      if (this.formModal.task && this.formModal.task.id) {
        data[0].unshift("ID");
        data[1].unshift(this.formModal.task.id);
      }
      data = data.map((row) => row.join(","));
      data = data.join("\r\n");
      let file = new Blob([data], { type: "text/csv;charset=utf-8;" });
      await this.importTasks(
        {
          // order_create_day: this.dateParser(form.order_create_day),
          order_type: form.order_type,
          order_subtype: form.order_subtype,
          priority: form.priority,
          order_description: form.order_description,
          // order_tag_id: form.tag,
          order_tag_names: (form.tags || []).length ? form.tags : undefined,
          failure_code_id: form.failure_code_id,
          repair_code_id: form.repair_code_id,
          file,
        },
        true
      );
      // Display group records belonging to the updated task
      if (this.formModal.task) {
        const task = this.tasks.find((v) => v.id == this.formModal.task.id);
        if (task && task.headerLog) {
          this.orderTemplate = task.headerLog.id;
        }
      }
      this.formModal.task = null;
      this.formModal.active = false;
    },
    onTableFetch(data) {
      this.tasks = data;
      this.$emit("fetch", data);
    },
  },
};
</script>

<style lang="scss">
.tasks-table {
  .b-table,
  .table-wrapper {
    height: 53vh !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/OrdersScheduler/tasks/index.vue